export enum EffectTypes {
    transparency,
    color,
    underline,
    animation,
}

export const TRANSPARENCY_SIZE_MAX = 100;
export const FONT_SIZE_MAX = 72;
